// extracted by mini-css-extract-plugin
module.exports = {"section":"StoryBrowse_section__LxD39","main":"StoryBrowse_main__M1SiQ","heading-container":"StoryBrowse_heading-container__lViNc","cards-flex":"StoryBrowse_cards-flex__UWn5S"};